(() => {
  const dialog = document.getElementById('DrapeurQuickAdd');
  if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
  dialog.dataset.ready = 'true';
  const form = dialog.querySelector('[data-quick-add-form]');
  const variants = dialog.querySelector('[data-quick-add-variants]');
  const submit = dialog.querySelector('[data-quick-add-submit]');
  const status = dialog.querySelector('[data-quick-add-status]');
  const cart = dialog.querySelector('[data-quick-add-cart]');
  const price = dialog.querySelector('[data-quick-add-price]');
  const root = dialog.dataset.root.replace(/\/?$/, '/');
  let opener, pending = false, added = false, request;
  let generation = 0;
  const money = cents => new Intl.NumberFormat(dialog.dataset.locale, {style:'currency', currency:window.Shopify?.currency?.active || dialog.dataset.currency || 'EUR'}).format(cents / 100);
  function close() { if (!pending) dialog.close(); }
  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-quick-add]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (pending) return;
    opener = trigger;
    added = false;
    const current = ++generation;
    request?.abort();
    request = new AbortController();
    const controller = request;
    const timer = setTimeout(() => controller.abort(), 12000);
    form.hidden = true;
    cart.hidden = true;
    submit.disabled = true;
    variants.replaceChildren();
    price.textContent = '';
    dialog.querySelector('h2').textContent = dialog.dataset.add;
    status.textContent = dialog.dataset.loading;
    dialog.showModal();
    document.documentElement.classList.add('drapeur-quick-add-open');
    try {
      const response = await fetch(root + 'products/' + encodeURIComponent(trigger.dataset.quickAdd) + '.js', {signal:controller.signal});
      if (!response.ok) throw new Error();
      const product = await response.json();
      if (current !== generation) return;
      dialog.querySelector('h2').textContent = product.title;
      status.textContent = '';
      if (!product.available) { status.textContent = dialog.dataset.soldOut; return; }
      const defaultVariant = product.variants.length === 1 && product.variants[0].title === 'Default Title';
      dialog.querySelector('[data-quick-add-options]').textContent = defaultVariant ? '' : product.options.map(option => option.name).join(' / ');
      product.variants.forEach(variant => {
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'radio'; input.name = 'id'; input.value = String(variant.id); input.required = true;
        input.disabled = !variant.available;
        const name = document.createElement('span');
        name.textContent = defaultVariant ? product.title : variant.title;
        if (!variant.available) input.setAttribute('aria-label', variant.title + ' — ' + dialog.dataset.soldOut);
        input.addEventListener('change', () => { submit.disabled = !cart.hidden; price.textContent = money(variant.price); });
        label.append(input, name); variants.append(label);
        if (defaultVariant && variant.available) { input.checked = true; submit.disabled = false; label.hidden = true; }
      });
      price.textContent = money(product.price);
      form.hidden = false;
    } catch (_) {
      if (current === generation) status.textContent = dialog.dataset.unavailable;
    } finally { clearTimeout(timer); }
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (pending || !form.reportValidity()) return;
    pending = true;
    submit.disabled = true;
    submit.classList.add('btn--loading');
    dialog.querySelector('[data-quick-add-close]').disabled = true;
    status.textContent = '';
    const id = Number(new FormData(form).get('id'));
    form.querySelector('fieldset').disabled = true;
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id,quantity:1}]})});
      const data = await response.json();
      if (!response.ok || data.status) {
        status.textContent = typeof data.description === 'string' ? data.description : dialog.dataset.unavailable;
        return;
      }
      added = true;
      pending = false;
      dialog.close();
      if (window.theme?.settings?.cartType === 'drawer' && document.getElementById('CartDrawer')) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail:{product:data.items[0],addToCartBtn:opener}}));
      } else location.assign(root + 'cart');
    } catch (_) {
      status.textContent = dialog.dataset.error;
      cart.hidden = false;
    } finally {
      pending = false;
      form.querySelector('fieldset').disabled = false;
      submit.disabled = !cart.hidden;
      submit.classList.remove('btn--loading');
      dialog.querySelector('[data-quick-add-close]').disabled = false;
    }
  });
  dialog.querySelector('[data-quick-add-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', event => { if (pending) event.preventDefault(); });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
  });
  dialog.addEventListener('close', () => {
    generation++; request?.abort();
    document.documentElement.classList.remove('drapeur-quick-add-open');
    if (!added) opener?.focus();
  });
})();
